/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ITermsAndConditionsPageData } from './terms-and-conditions-page.data';
import { ITermsAndConditionsPageProps } from './terms-and-conditions-page.props.autogenerated';

export interface ITermsAndConditionsPageViewProps extends ITermsAndConditionsPageProps<ITermsAndConditionsPageData> {}

/**
 *
 * TermsAndConditionsPage component
 * @extends {React.PureComponent<ITermsAndConditionsPageProps<ITermsAndConditionsPageData>>}
 */
class TermsAndConditionsPage extends React.PureComponent<ITermsAndConditionsPageProps<ITermsAndConditionsPageData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default TermsAndConditionsPage;
